import { render, staticRenderFns } from "./RoleListActions.vue?vue&type=template&id=24e63c12&scoped=true"
import script from "./RoleListActions.vue?vue&type=script&lang=js"
export * from "./RoleListActions.vue?vue&type=script&lang=js"
import style0 from "./RoleListActions.vue?vue&type=style&index=0&id=24e63c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e63c12",
  null
  
)

export default component.exports